import React, { Component } from 'react'
import './index.css';
import IconClose from '../IconClose'
import { CATEGORIES } from '../../constants';
import { Tooltip } from '@mui/material';
const colorFloatClass = (color) => "LucketCategoryIcon statusfloat-" + color;

class LucketCategory extends Component {

    state = {
        edit: false
    }


    edit = () => {
        if (this.state.edit === false) {
            this.setState({ edit: true })
        } else {
            this.setState({ edit: false })
        }

    }

    set = (event, v) => {
        event.stopPropagation();
        this.setState({ edit: false });
        this.props.updateLucket(v, "category", this.props.childLucket && this.props.lucket, this.props.childLucketIndex);
    }

    setPoints = (event, v) => {

        event.stopPropagation();
        if (v === "plus") {
            let lucket = { ...this.props.lucket };
            let order = Number(lucket.order)
            if (order && lucket.order < 25) {
                order += 1;
            }
            if (!order) { order = 1 }

            this.props.updateLucket(order, "order", this.props.childLucket && this.props.lucket, this.props.childLucketIndex);
        }
        if (v === "minus") {
            let lucket = { ...this.props.lucket };
            let order = Number(lucket.order)
            if (order && order > 1) {
                order -= 1;
            }
            if (!order) { order = 1 }

            this.props.updateLucket(order, "order", this.props.childLucket && this.props.lucket, this.props.childLucketIndex);
        }
    }

    render() {


        let options = CATEGORIES;


        const categoryEditor = (this.state.edit === true) ?
            <div className="CategoryEditorWrapper">
                <div className="CategoryCallout" />
                <div id="menu" className="CategoryMenu">
                    {options.filter(
                        o => o !== this.props.status
                    ).map(o =>
                        <div key={o} className={'LucketCategoryIconShort'}
                            onClick={(e) => this.set(e, o)} >{o}</div>
                    )}

                    <div key={"minus"} style={{ paddingRight: "20px" }} className={'LucketCategoryIcon ' + colorFloatClass("minus")}
                        onClick={(e) => this.setPoints(e, "minus")} >
                        <img src={'/images/minus.svg'} className="CategoryImage" alt="minus.svg" />
                    </div>

                    <div key={"plus"} style={{ paddingRight: "10px" }} className={'LucketCategoryIcon ' + colorFloatClass("plus")}
                        onClick={(e) => this.setPoints(e, "plus")} >
                        <img src={'/images/add.svg'} className="CategoryImage" alt="add.svg" />
                    </div>

                    <IconClose edit={this.edit} key={"close"} />

                </div></div> : null

        return (<Tooltip title="Category and Order">
            <div className={'LucketCategoryIcon'}
                onClick={this.edit}>

                {!this.props.planView && this.props.lucket.category}

                {this.props.lucket.order}

                {categoryEditor}

            </div>
        </Tooltip>
        )
    }

}

export default LucketCategory